import _ from 'lodash';

export function doesTabHaveFilter(panels, tabIdx, filterName) {
  const filters = _.get(panels, `member.${tabIdx}.customViews`);
  return _.find(filters, o => {
    const { name } = o;
    const lowerCaseName = _.toLower(name);
    return lowerCaseName === _.toLower(filterName);
  });
}

export function isDirectLink() {
  return _.includes(_.get(window, 'location.pathname', ''), '/find');
}
